// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__W5W93","rootSuccess":"CompleteLink_rootSuccess__2O4Fh","rootFailure":"CompleteLink_rootFailure__2Moqk","isDisabled":"CompleteLink_isDisabled__2MwAo"};